import angular from 'angular';
import ownerFormComponent from './owner-form.component';

export default angular.module('components.app.adverseEvent.ownerForm', [])
  .component('ownerForm', ownerFormComponent)
  .value('EventEmitter', payload => ({ $event: payload }))
  .name;



// WEBPACK FOOTER //
// ./components/app/adverse-event/owner-form/owner-form.module.js